module.exports = __webpack_public_path__ + "img/cert.329d1c0f.png";